import {
    getSquareOnlineStoreRestaurantBrief,
    getSquareOnlineStoreRestaurantBriefVariables,
} from '__generated__/getSquareOnlineStoreRestaurantBrief';
import { SquareOnlineStoreRestaurantBriefFields } from '__generated__/SquareOnlineStoreRestaurantBriefFields';
import { AuthConsumer } from 'projects/components/AuthContext';
import Brief from 'projects/routes/Brief';
import BriefQuery from 'projects/routes/BriefQuery';
import { BriefStep, StepState } from 'projects/util/step';
import React from 'react';
import { useApolloClient } from 'react-apollo';
import { Route, Switch, useRouteMatch } from 'react-router';
import DetailsPage from './DetailsPage';
import queries from './SquareOnlineStoreRestaurant.graphql';
import SummaryPage from './SummaryPage';

interface Props {
    briefId: string;
    step: string;
}

const steps: BriefStep<SquareOnlineStoreRestaurantBriefFields>[] = [
    {
        step: 1,
        title: __('Tell us about your project'),
        fields: [
            'title',
            'existingWebsite',
            'description',
            'googleDriveUrl',
            'referenceFiles',
            'other',
        ],
    },
    { step: 2, title: __('Review your brief') },
];

export function SquareOnlineStoreRestaurant() {
    const route = useRouteMatch<Props>();
    const client = useApolloClient();

    return (
        <BriefQuery<
            getSquareOnlineStoreRestaurantBrief,
            getSquareOnlineStoreRestaurantBriefVariables
        >
            query={queries.getSquareOnlineStoreRestaurantBrief}
            variables={{ id: route!.params.briefId }}
            fieldsTypename="SquareOnlineStoreRestaurantBriefFields"
        >
            {(data, refetch) => {
                const { viewer } = data;
                const brief = {
                    ...data.brief,
                    fields: data.brief.fields as SquareOnlineStoreRestaurantBriefFields,
                };

                const step = new StepState({
                    steps,
                    brief: data.brief,
                    currentStep: parseInt(route!.params.step, 10),
                });

                return (
                    <AuthConsumer>
                        {({ login }) => (
                            <Brief
                                refetch={refetch}
                                schema="squareOnlineStoreRestaurant"
                                brief={brief}
                                viewer={viewer}
                                login={login}
                                stepState={step}
                                client={client}
                                disableFooterInteraction
                            >
                                {form => (
                                    <Switch>
                                        <Route
                                            path={`/briefs/square-online-store-restaurant/:briefId/1`}
                                            render={() => <DetailsPage form={form} brief={brief} />}
                                        />
                                        <Route
                                            path={`/briefs/square-online-store-restaurant/:briefId/2`}
                                            render={() => <SummaryPage brief={brief} />}
                                        />
                                    </Switch>
                                )}
                            </Brief>
                        )}
                    </AuthConsumer>
                );
            }}
        </BriefQuery>
    );
}
